module.exports = __webpack_public_path__ + "static/fatherdaynamevest-6b0add4e4ac3eef7273f0a1e391120f9.jpeg";